import React from 'react';
import Grid from '@mui/material/Grid';
import { ZuiSpinner } from 'components/Zui/ZuiSpinner';

/**
 * MiZuiSpinner component renders a centered spinner when the `active` prop is true.
 *
 * @component
 * @param props - The properties object.
 * @param props.active - Determines whether the spinner should be displayed.
 * @returns The rendered spinner component or null if not active.
 */
const MiZuiSpinner: React.FC = () => {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '0vh' }}
    >
      <Grid item xs={12}>
        <ZuiSpinner active></ZuiSpinner>
      </Grid>
    </Grid>
  );
};

export default MiZuiSpinner;
